export enum AppLanguages {
  EN = 'en',
  VI = 'vi',
}

export const APP_TRANSLATE_KEY = 'translate';
export const STORAGE_LANGUAGE_KEY = 'idurar_app_language';
export const APP_SETTINGS_KEY = 'app_settings';

export interface AppMenuItem {
  key: string;
  icon?: React.ReactNode;
  label: React.ReactNode | string;
  hidden?: boolean; // Optional property to control visibility
}

export interface AppMenuItems extends AppMenuItem {
  children?: AppMenuItems[];
}

export interface LanguageContextType {
  translate: (key: string) => string;
  setLanguage: (langCode: AppLanguages) => void;
  appLanguage: AppLanguages;
}

export interface AppSettings {
  app_language: AppLanguages;
}
